'use client';
// src/components/Toast.js
import { useToast as useShadcnToast } from '@/hooks/use-toast';
import { CheckCircle, XCircle, Info } from 'lucide-react';

// Create a singleton instance to manage toast globally
let toastFunction = null;

export const initializeToast = (toastFn) => {
    toastFunction = toastFn;
};

export const toast = {
    success: (message) => {
        if (toastFunction) {
            toastFunction({
                description: (
                    <div className="flex items-center gap-2">
                        <CheckCircle className="w-5 h-5 text-green-500" />
                        <span>{message}</span>
                    </div>
                ),
                className: "bg-green-50 border-green-200 text-green-800",
            });
        }
    },
    error: (message) => {
        if (toastFunction) {
            toastFunction({
                description: (
                    <div className="flex items-center gap-2">
                        <XCircle className="w-5 h-5 text-red-500" />
                        <span>{message}</span>
                    </div>
                ),
                className: "bg-red-50 border-red-200 text-red-800",
                variant: "destructive",
            });
        }
    },
    info: (message) => {
        if (toastFunction) {
            toastFunction({
                description: (
                    <div className="flex items-center gap-2">
                        <Info className="w-5 h-5 text-blue-500" />
                        <span>{message}</span>
                    </div>
                ),
                className: "bg-blue-50 border-blue-200 text-blue-800",
            });
        }
    }
};

// Component to initialize the toast (add this to your root layout)
const Toast = () => {
    const { toast: shadcnToast } = useShadcnToast();
    
    // Initialize on mount
    if (typeof window !== 'undefined' && !toastFunction) {
        initializeToast(shadcnToast);
    }
    
    return null;
};

export default Toast;